<template>
    <div>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="15">
                <el-card class="box-card card">
                    <el-row>
                        <el-col :span="24">
                            <div class="grid-content bg-purple-dark info-box">
                                <span class="title">公司基本信息</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                        <div class="grid-content bg-purple-dark form">
                            <el-form :label-position="labelPosition" label-width="110px" :model="formLabelAlign">
                                    <el-form-item label="公司logo">
                                       <el-avatar class="company-logo" shape="square" :size="50" :src="logo"></el-avatar>
                                    </el-form-item>
                                    <el-form-item label="公司名称">
                                        <el-input
                                            class="inp text-bg define-inp"
                                            readonly="readonly"
                                            v-model="simpleName" 
                                            >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="公司简称">
                                        <el-input
                                            class="inp text-bg define-inp"
                                            readonly="readonly"
                                            v-model="name" 
                                            >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="行业">
                                        <el-input
                                            class="inp text-bg"
                                            v-model="industryName" 
                                            >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="公司性质">
                                        <el-select v-model="companyFeatureId" @change="getPositionName('companyFeatureArr','companyFeatureId','companyFeatureVal','name')" placeholder="请选择公司性质" class="inp text-bg">
                                            <el-option
                                            v-for="item in companyFeatureArr"
                                            :key="item.sortNo"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="人员规模">
                                        <el-select v-model="serviceProjectId" @change="getPositionName('serviceProjectArr','serviceProjectId','serviceProjectVal','name')" placeholder="请选择人员规模" class="inp text-bg">
                                            <el-option
                                            v-for="item in serviceProjectArr"
                                            :key="item.sortNo"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="公司官网">
                                        <el-input
                                            class="inp text-bg"
                                            v-model="companyWeb" 
                                            >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="公司电话">
                                        <el-input
                                            class="inp text-bg"
                                            v-model="companyTel" 
                                            >
                                        </el-input>
                                    </el-form-item>
                                    
                                </el-form>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="grid-content bg-purple-dark form">
                                <el-form :label-position="labelPosition" label-width="110px" :model="formLabelAlign">
                                    <el-form-item label="地址">
                                        <el-input
                                            class="inp text-bg"
                                            placeholder="请填写公司地址"
                                            v-model="companyAddress" 
                                            >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="工作时间">
                                       <el-time-picker
                                            is-range
                                            v-model="workingTime"
                                            range-separator="-"
                                            start-placeholder="开始时间"
                                            end-placeholder="结束时间"
                                            placeholder="选择时间范围"
                                            format="HH:mm"
                                            value-format="HH:mm">
                                        </el-time-picker>
                                    </el-form-item>

                                    <el-form-item label="公司福利" @click.native="isClose=true" class="company-welfare">
                                        <div>
                                            <div class="tipBox inp">请选择公司福利<i class="el-icon-plus"></i></div>
                                        </div>
                                    </el-form-item>

                                     <el-row type="flex" class="row-bg company-welfare" justify="center">
                                        <el-col :span="24">
                                            <el-col :span="21" style="margin-left:12%;">
                                                <div class="grid-content bg-purple">
                                                    <el-card class="box-card inp" style="position:relative;" v-if="isClose">
                                                        <i class="el-icon-error" @click="isClose=false" style="font-size:25px;cursor:pointer;position:absolute;right:0;top:0;"></i>
                                                        <el-tag
                                                        @click.native="selectedIcon(tag,index)"
                                                        :key="index"
                                                        v-for="(tag,index) in dynamicTags"
                                                        :closable="tag.relevanceId!=null"
                                                        :disable-transitions="false"
                                                        @close="handleClose(tag)" style="cursor:pointer;margin:2px;">
                                                        {{tag.name}}
                                                        </el-tag>
                                                        <el-input
                                                        class="input-new-tag"
                                                        v-if="inputVisible"
                                                        v-model="inputValue"
                                                        ref="saveTagInput"
                                                        size="small"
                                                        maxlength="10"
                                                        @keyup.enter.native="handleInputConfirm"
                                                        @blur="handleInputConfirm"
                                                        >
                                                        </el-input>
                                                        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 创建自己特色的服务</el-button>

                                                    </el-card>
                                                </div>
                                            </el-col>
                                        </el-col>
                        
                                    </el-row>


                                    <el-form-item label="公司环境" style="margin-top:20px;">
                                        <el-upload class="image-update update-img" :limit="5"
                                            action="https://upload.xuruidea.com/uploadFile?type=1"
                                            list-type="picture-card"
                                            :on-success="handleAvatarSuccess"
                                            :file-list="companyPhotoList">
                                            <i slot="default" class="el-icon-plus"></i>
                                            <div slot="file" slot-scope="{file}">
                                            <img
                                                class="el-upload-list__item-thumbnail aa"
                                                :src="file.url" alt=""
                                            >
                                            
                                            <span class="el-upload-list__item-actions">
                                                <span
                                                class="el-upload-list__item-preview"
                                                @click="handlePictureCardPreview(file)"
                                                >
                                                <i class="el-icon-zoom-in"></i>
                                                </span>
                                                
                                                <span
                                                v-if="!disabled"
                                                class="el-upload-list__item-delete"
                                                @click="handleRemove(file)"
                                                >
                                                <i class="el-icon-delete"></i>
                                                </span>
                                            </span>
                                            </div>
                                            
                                        </el-upload>
                                        <span class="img-hint">（最多可以上传五张照片）</span>
                                        <el-dialog :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                        </el-dialog>
                                        
                                    </el-form-item>

                                    
                                    <el-form-item label="公司简介">
                                        <el-input class="inp text-bg"
                                        type="textarea"
                                        :rows="10"
                                        placeholder="请介绍一下公司详情"
                                        v-model="details"
                                        maxlength="3000"
                                        show-word-limit
                                        >
                                        </el-input>
                                    </el-form-item>
                                    
                                </el-form>
                            </div>
                        
                        </el-col>
                    </el-row>
                    <!-- <el-row type="flex" justify="center">
                        <el-col :span="16">
                            <el-checkbox v-model="checked" style="" class="check">已阅读并遵循《东营人力人力职位信息发布规则》</el-checkbox>
                        </el-col>
                    </el-row> -->
                    <el-row type="flex" justify="center" class="btn_fb">
                        <el-col :span="16">
                            <el-button type="primary theme-btn">
                                <span @click="saveCompany">保 存</span>
                            </el-button>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

       
    </div>
</template>
<script>
import {getBasicsData,addRelevance,searchRelevance} from '@/utils/publicInterfece.js'
export default {
    data(){
        return{
            userInfo:'',    // 用户信息

            logo:'', // 公司logo
            simpleName:'',  // 公司简称
            name:'',    // 公司全称
            companyAddress:'',  // 企业地址
            companyWeb:'',     // 公司官网
            companyAddress:'',  // 公司地址
            companyTel:'',  // 公司电话
            industryName:'',    // 行业
            dialogImageUrl: '', 
            companyFeatureId:'',   // 公司性质id
            companyFeatureVal:'',   // 公司性质名称
            companyFeatureArr:[],   // 公司性质数据
            serviceProjectId:'',    // 人员规模id
            serviceProjectVal:'',   // 人员规模名称
            serviceProjectArr:[],   // 人员规模数据
            workingTime:[],  // 工作时间
            // workingTimeStart:'',    // 开始时间
            // workingTimeEnd:'',  // 结束时间
            selecteddynamicTags:[], //已选择的公司福利
            dynamicTags:[],      // 所有的公司福利
            companyPhotoList:[],    // 公司环境
            companyPhotoListArr:[],    // 要上传的公司环境
            
            details:'',     // 公司简介
            dialogVisible: false,
            disabled: false,


            // dynamicTags: ['标签一', '标签二', '标签三'],
            inputVisible: false,
            inputValue: '',
            isClose:false,

            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                region: '',
                type: ''
            },
            options: [{
                value: '选项1',
                label: '黄金糕'
            }],
            urgency:[{
                value:'选项1',
                label:'是'
                },
                {
                value:'选项2',
                label:'否'
            }],
            checked:false,

            inputVisible: false,
            inputValue: '',
            featureSelect:'',
            tempSelectArr:[],
            isClose:false,
            }
    },
    methods:{
        test(){
            console.log('test')
            // console.log(this.workingTimeStart,this.workingTimeEnd)
            // console.log(new Date(this.workingTime))
            console.log(this.workingTime)
        },
    
    // 公司相册
    // 删除
        handleRemove(file) {
            // console.log('删除')
            // console.log(file);
            // console.log(this.companyPhotoList)
            this.companyPhotoList.forEach((item,index)=>{
                
                if(item.id==file.id){
                    // console.log('item')
                    // console.log(this.companyPhotoList)
                    // console.log(this.companyPhotoListArr)
                    this.companyPhotoList.splice(index,1)
                    this.companyPhotoListArr.splice(index,1)
                }
            })

        },
    // 上传
        handleAvatarSuccess(res,file){
            // console.log('aabb')
            this.companyPhotoListArr.push(file.response.data.url)
            // console.log(this.companyPhotoListArr)
        },
    // 放大
        handlePictureCardPreview(file) {
            //  console.log('放大')
            //  console.log(this.companyPhotoList)
             this.dialogImageUrl = file.url;
             this.dialogVisible = true;
        },


// 公司福利

        // 公司福利函数删除
        handleClose(tag) {
            // console.log('tagg')
            // console.log(tag)
            this.axiosPost(`/commonRelevance/deleteById/${tag.id}`
            ).then((res)=>{
                if(res.code==200){
                    this.$message({
                        type:'success',
                        message:res.message
                    })
                }
                // console.log(res)
            })
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },
        showInput() {
            // console.log('qqq')
            this.inputVisible = true;
            this.$nextTick(_ => {
            this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {

            this.axiosPost(`/commonRelevance/addRelevance`,
                {
                    relevanceId:this.userInfo.companyId,
                    name:this.inputValue,
                    type:'1'
                }
            ).then((res)=>{
                this.inputVisible = false;
                this.inputValue = '';
                if(res.code==200){
                    this.getAllCompanyWelfare()
                }
            })
        },

        

        // 选择公司福利
        selectedIcon(tab,index){
            // console.log(tab)
            let tipBox = document.querySelector('.tipBox')
            // console.log('tipBox')
            // console.log(tipBox.nodeValue)
            if(tipBox.innerHTML=='请选择公司福利'){
                tipBox.innerHTML = ''
            }
            
            let tip = document.createElement('span')
            let i = document.createElement('i')
            i.className='el-tag__close el-icon-close'
            // i.setAttribute('onclick','delTip')
            tip.className='el-tag el-tag--light tip'
            tip.appendChild(document.createTextNode(tab.name))
            tip.appendChild(i)
            tipBox.appendChild(tip)
            this.dynamicTags.splice(index,1)
            
            this.selecteddynamicTags.splice(index,0,tab)
            // console.log('selecteddynamicTags')
            // console.log(this.selecteddynamicTags)
            i.onclick = ()=>{
                // 当前的tip,当前tab的索引,当前的tab,存放tip的盒子
                this.delTip(tip,index,tab,tipBox)
            }  


            // this.tempSelectArr.push(tabName)
            // this.featureSelect = [...new Set(this.tempSelectArr)].join(',')
        },
        delTip(tip,index,tab,tipBox){
            // console.log('tap')
            // console.log(tab)
            // console.log('tip')
            // console.log(tip)
            this.dynamicTags.splice(index,0,tab)
            tip.parentNode.removeChild(tip)
            this.selecteddynamicTags.splice(index,1)
            console.log(this.selecteddynamicTags)
            if(tipBox.innerHTML==''){
                console.log('tipBox')
                tipBox.innerHTML='请选择公司福利'
            }
        },
       
        
        getAllCompanyWelfare(){
            // 获取全部公司福利  
            searchRelevance(this,this.userInfo.companyId,'company_welfare','1').then((res)=>{
                // console.log('公司福利')
                // console.log(res)
                if(res.code==200){
                    this.dynamicTags = res.data
                    // console.log('TagTip')
                    // console.log(res.data)
                }

            })
        },



    // 获得数据（数组，id，值，目标值,隐藏属性,隐藏属性值）
        getPositionName(arr,id,val,targetVal,statusAttr,statusVal){
            // console.log('arr')
            // console.log(this[id])
            let obj = this[arr].find((item)=>{
                return item.id == this[id];
            })
            // console.log(obj)
            this[val] = obj[targetVal]
            if(statusAttr){
                this[statusAttr] = statusVal
            }
            // console.log("获取数据")
            // console.log(this[val])
        },
        saveCompany(){
            let that = this
            this.axiosPost(`/companyPhoto/addPhotoList`,
                {
                    companyId:this.userInfo.companyId,
                    urlArr:this.companyPhotoListArr
                }
            ).then((res)=>{
                // console.log('公司环境')
                // console.log(res)
                let status = res.code==200?'success':'error'
                
                    this.$message({
                        type:status,
                        message:res.message,
                        showClose:true,
                        duration:1500
                    })
            })
        // 保存公司福利
            this.axiosPost(`/companyWelfare/save`,
                {
                    relevanceId:this.userInfo.companyId,
                    type:1,
                    commonRelevanceDtoList:this.selecteddynamicTags
                }
            ).then((res)=>{
                // console.log('公司福利保存')
                // console.log(res)
            })
            this.axiosPost(`/company/update`,
                {
                    id:this.userInfo.companyId,  // 公司id
                    logo:this.logo, // 公司logo
                    simpleName:this.simpleName, // 公司简称
                    name:this.name, // 公司全称
                    industryName:this.industryName,    // 行业
                    companyNatureId:this.companyFeatureId,   // 公司性质id
                    companyNature:this.companyFeatureVal,   // 公司性质名称
                    personnelSizeId:this.serviceProjectId,    // 人员规模id
                    personnelSize:this.serviceProjectVal,   // 人员规模名称
                    workingTimeStart:this.workingTime[0] || '',   // 开始时间
                    workingTimeEnd:this.workingTime[1] || '',     // 结束时间
                    companyWeb:this.companyWeb, // 公司官网
                    details:this.details,   // 公司简称
                    companyTel:this.companyTel,  // 公司电话     
                }
            ).then((res)=>{
                // console.log('保存')
                // console.log(res)
                if(res.code==200){
                    // this.$message({
                    //     type:"success",
                    //     message:res.data.message,
                    //     duration:1500
                    // })
                    console.log('getStautsFngetStautsFn')
                    that.$emit('getStautsFn',1)
                }
            })
        },
        renden(selectedListArr){
            // console.log('AllListArr')
            // console.log(AllListArr)
            let tipBox = document.querySelector('.tipBox')
            if(tipBox.innerHTML=="请选择公司福利"){
                tipBox.innerHTML=""
            }
            selectedListArr.forEach((item,index)=>{
                let tip = document.createElement('span')
                let i = document.createElement('i')
                i.className='el-tag__close el-icon-close'
                tip.className='el-tag el-tag--light tip'
                tip.appendChild(document.createTextNode(item.name))
                tip.appendChild(i)
                tipBox.appendChild(tip)
                i.onclick = ()=>{
                    // console.log('item')
                    // console.log(item)
                   // 当前的tip,当前tab的索引,当前的tab对象,存放tip的盒子
                    this.delTip(tip,index,item,tipBox)
                }  
            })
        }
    },
    created(){
        this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        // console.log('用户信息')
        // console.log(userInfo)
    // 获取公司性质
        getBasicsData(this,'company_nature').then((res)=>{
            // console.log('公司性质')
            // console.log(res)
            if(res.code==200){
                // console.log(res.data)
                this.companyFeatureArr = res.data
            }
        })
    // 获取人员规模
        getBasicsData(this,'company_size').then((res)=>{
            // console.log('人员规模')
            // console.log(res)
            if(res.code==200){
                // console.log(res.data)
                this.serviceProjectArr = res.data
            }
        })
    // 获取公司福利
        this.getAllCompanyWelfare()

    // 获取公司信息
        this.axiosGet(`/company/findById/${this.userInfo.companyId}`).then((res)=>{
            // console.log('公司')
            // console.log(res)
            if(res.code==200){
                this.logo = res.data.logo   // 公司logo
                this.simpleName = res.data.simpleName   // 公司简称
                this.name = res.data.name   // 公司名称
                this.industryName = res.data.industryName   // 行业
                this.companyFeatureId = res.data.companyNatureId+''    // 公司性质
                this.companyFeatureVal = res.data.companyNature     // 公司性质
                this.serviceProjectId = res.data.personnelSizeId+''  // 人员规模
                this.serviceProjectVal = res.data.personnelSize //  人员规模值
                this.companyWeb = res.data.companyWeb   // 公司官网
                this.companyTel = res.data.companyTel   // 公司电话
                this.companyAddress = res.data.companyAddress   // 公司地址

                let workingTimeStart = res.data.companyWork.workingTimeStart || ''
                let workingTimeEnd = res.data.companyWork.workingTimeEnd || ''
                this.workingTime.push(workingTimeStart,workingTimeEnd)    // 工作时间
    
                res.data.companyPhotoList.forEach((item,index)=>{
                    this.companyPhotoListArr.push(item.url)
                })
                this.companyPhotoList = res.data.companyPhotoList // 公司环境

                this.details = res.data.details // 公司简称
                this.selecteddynamicTags = res.data.welfareUseList  // 存放已选择的公司福利
                
                // console.log('已选择的公司福利')
                // console.log(this.selecteddynamicTags)
                this.renden(this.selecteddynamicTags,this.dynamicTags)
                // console.log('companyFeatureArr')
                // console.log(res.data.companyFeatureArr)
                
                // console.log('work')
                // console.log(this.workingTime)
            }
        })
    }
}
</script>
<style lang="less" scoped>
    
    .inp{
        width:80%;
    }
    .num{ 
        font-size: 48px;
        font-weight: 500;
        color: #197FFB;
        line-height: 74px;
        margin-right:10px;
    }
    .el-input.is-disabled .el-input__inner{
        cursor:default;
    }
    .info-box{
        padding-left:50px;
        margin-top:20px;
        margin-bottom:30px;
    }
    .form{
        padding-left:78px;
    }
    .title{     
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
        position:relative;
        bottom:5px;
    }
    .chck{
        font-size: 14px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }
    .el-col-offset-8{
        margin-left:40.3333%
    }
    .btn_fb{
        // margin-top:20px;
    }
    .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .img-hint{  
    font-size: 18px;
    font-weight: 400;
    color: #858DA7;
    line-height: 30px;
  }
  .row-bg{
        margin-top:20px;
  }

    .update-img {
        display:inline-block;
        vertical-align:bottom;
    }

// 公司福利
    .company-welfare{
        margin:0;
    }
    .tipBox{
        display:inline-block;
        min-height:40px;
        border: 1px solid #DCDFE6;
        background-color: #EEF2FB;
        border-radius:4px;
        cursor:pointer;
        box-sizing:border-box;
        padding-left:15px;
        color: #606266;
    }

    .check,
    .theme-btn{
        float:right;
    }
</style>